const TableConfig = {
  stylesPerColumn: [
    {
      fontSize: 14,
      fontWeight: 500,
      color: "dark.1"
    },
    {
      fontSize: 16,
      color: "primary.0",
      fontWeight: 600
    },
    {
      fontSize: 16,
      color: "primary.0",
      fontWeight: 600
    },
    {
      fontSize: 14,
      fontWeight: 500,
      color: "dark.1"
    },
    { justifyContent: "center", alignItems: "center" }
  ],
  columnWidths: [1, 1, 1, 1, 1],
  main: {
    borderRadius: "10px"
  },
  heading: {
    fontSize: 16,
    fontWeight: 500,
    color: "dark.3",
    py: 2
  },
  head: {
    bg: "dark.7"
  },
  data: {
    py: 2,
    borderTop: "1px solid",
    borderColor: "dark.6"
  }
}

const Headings = [
  { id: "id", title: "User ID" },
  { id: "firstName", title: "First Name" },
  { id: "lastName", title: "Last Name" },
  { id: "company", title: "Company" },
  { id: "viewBtn", title: "View More" }
]

const COMPANIES_TO_LOAD = 50

export { TableConfig, Headings, COMPANIES_TO_LOAD }
